import React, { useState, useEffect, useRef } from 'react';
import { TagService } from "../service/TagService";
import classNames from 'classnames';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { AuthorizationService, MANAGE_TAGS } from '../service/AuthorizationService';
import './Crud.scss'
import * as _ from 'lodash';
import { ProgressBar } from 'primereact/progressbar';
import { v4 as uuidv4 } from 'uuid';
import { LanguageService } from "../service/LanguageService";
import { ToggleButton } from 'primereact/togglebutton';

export function ClientTagValueCrud(props) {

    let emptyTagValue = {
        id: uuidv4(),
        name: '',
        tag_id: props.match.params.id
    };

    const [tag, setTag] = useState({});
    const [tagValueDialog, setTagValueDialog] = useState(false);
    const [deleteTagValueDialog, setDeleteTagValueDialog] = useState(false);
    const [tagValue, setTagValue] = useState(emptyTagValue);
    const [selectedTagValues, setSelectedTagValues] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [hasAccess, setHasAccess] = useState(false);
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isNew, setIsNew] = useState(true);
    const toast = useRef(null);
    const dt = useRef(null);
    const tagService = new TagService();
    const authorizationService = new AuthorizationService();
    const languageService = new LanguageService();
    
    const updateList = async () => {
        const data = await tagService.get({ id: props.match.params.id });
        setTag(data);
    }

    const { match } = props;
    useEffect(() => {
        setHasAccess(authorizationService.hasPermission(MANAGE_TAGS));

        if(authorizationService.hasPermission(MANAGE_TAGS)){
            async function fetchData() {
                await updateList();
                setLoading(false);
            }        
            fetchData();
            
        }
    }, [match]);

    const openNew = () => {
        setIsNew(true);
        emptyTagValue.id = uuidv4();
        setTagValue(emptyTagValue);
        setSubmitted(false);
        setTagValueDialog(true);
    }

    const hideDialog = () => {
        if(!saving){
            setSubmitted(false);
            setTagValueDialog(false);
        }
    }

    const hideDeleteTagValueDialog = () => {
        setDeleteTagValueDialog(false);
    }

    const saveDisabled = () => {
        return (tagValue.name || "") === "";
    }

    const saveTag = async () => {
        try {
            setSaving(true);
            setSubmitted(true);

            if (tagValue.name.trim()) {
                if (!isNew) {
                    tag.values.find(tv => tv.id === tagValue.id).name = tagValue.name;
                    tag.values.find(tv => tv.id === tagValue.id).is_default = tagValue.hasOwnProperty("is_default") ? tagValue.is_default : false;
                    console.log(tag);
                    await tagService.update(tag);
                    toast.current.show({ severity: 'success', summary: languageService.getText('Successful'), detail: languageService.getText('Item_Updated'), life: 3000 });
                }
                else {
                    tag.values = (tag.values || []).concat([tagValue]);
                     await tagService.update(tag);
                    toast.current.show({ severity: 'success', summary: languageService.getText('Successful'), detail: languageService.getText('Item_Created'), life: 3000 });
                }

                await updateList();
                setTagValueDialog(false);
                setTagValue(emptyTagValue);
                setSaving(false);
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });
            setSaving(false);
            console.log(error);
            throw error;
        }
    }

    const editTag = (tagValue) => {
        setIsNew(false);
        setTagValue({ ...tagValue });
        setTagValueDialog(true);
    }

    const confirmDeleteTagValue = (tagValue) => {
        setTagValue(tagValue);
        setDeleteTagValueDialog(true);
    }

    const deleteTagValue = async () => {
        try {
            setSaving(true);
            tag.values.find(tv => tv.id === tagValue.id).deleted = true;
            await tagService.update(tag);
            await updateList();
            setDeleteTagValueDialog(false);
            setTagValue(emptyTagValue);
            setSaving(false);
            toast.current.show({ severity: 'success', summary: languageService.getText('Successful'), detail: languageService.getText('Item_Deleted'), life: 3000 });    
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    const onInputChange = (e, name) => {
        onValueChange((e.target && e.target.value) || '', name);
    }

    const onValueChange = (val, name) => {
        console.log("onValueChange", val);
        let _tagValue = { ...tagValue };
        _.set(_tagValue, name, val);
        console.log("_tagValue", _tagValue);
        setTagValue(_tagValue);
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label={languageService.getText("New")} icon="pi pi-plus" className="p-button-success p-mr-2" onClick={openNew} />
            </React.Fragment>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2" onClick={() => editTag(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => confirmDeleteTagValue(rowData)} />
            </React.Fragment>
        );
    }

    const header = (
        <div className="table-header">
            <h5 className="p-m-0">{languageService.getText('Manage')} {tag.name}</h5>
        </div>
    );

    const tagValueDialogFooter = (
        <React.Fragment>
            { !saving && <Button label={languageService.getText("Cancel")} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />}
            { !saving && <Button disabled={saveDisabled()} label={languageService.getText("Save")} icon="pi pi-check" className="p-button-text" onClick={saveTag} />}
            { saving && <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="8"/>}
        </React.Fragment>
    );
    const deleteTagValueDialogFooter = (
        <React.Fragment>
            { !saving && <Button label={languageService.getText("No")} icon="pi pi-times" className="p-button-text" onClick={hideDeleteTagValueDialog} />}
            { !saving && <Button label={languageService.getText("Yes")} icon="pi pi-check" className="p-button-text" onClick={deleteTagValue} />}
            { saving && <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="8"/>}
        </React.Fragment>
    );

    if(hasAccess){

        return (
            <div className="datatable-crud-demo">
                <Toast ref={toast} />
                <div className="card">
                    { loading && <ProgressBar mode="indeterminate"/> }
                    { !loading && <Toolbar className="p-mb-4" left={leftToolbarTemplate}></Toolbar>}

                    { !loading &&
                    <>
                    <DataTable ref={dt} value={(tag.values || []).sort((a,b) => a.name > b.name ? 1 : -1)} selection={selectedTagValues} onSelectionChange={(e) => setSelectedTagValues(e.value)}
                        dataKey="id"
                        header={header}
                        autoLayout={true}
                        >

                        <Column field="name" header={languageService.getText("Name")}></Column>
                        <Column field="is_default" header={languageService.getText("Default_for_New_User")} body={(rowData) => rowData.is_default ? languageService.getText("Yes") : languageService.getText("No")}></Column>
                        <Column body={actionBodyTemplate}></Column>
                    </DataTable>
                    </>
                    }
                </div>

                <Dialog visible={tagValueDialog} style={{ width: '90vw' }} header={languageService.getText("Item_Details")} modal className="p-fluid" footer={tagValueDialogFooter} onHide={hideDialog}>
                    <div className="p-field">
                        <label htmlFor="name">{languageService.getText("Name")}*</label>
                        <InputText disabled={saving} id="name" value={tagValue.name} onChange={(e) => onInputChange(e, 'name')} required autoFocus className={classNames({ 'p-invalid': submitted && !tagValue.name })} />
                        {submitted && !tagValue.name && <small className="p-invalid">{languageService.getText("Name")} {languageService.getText("is_required")}.</small>}
                    </div>
                    <div className="p-field">
                        <label htmlFor="is_default">{languageService.getText("Default_for_New_User")}</label>
                    </div>
                    <div className="p-field">
                        <ToggleButton style={{width: 100}} onLabel={LanguageService.text("Yes")}  offLabel={LanguageService.text("No")}  onIcon="pi pi-check" offIcon="pi pi-times" checked={tagValue.is_default} onChange={(e) => onValueChange(e.value, 'is_default')} />
                    </div>
                </Dialog>

                <Dialog visible={deleteTagValueDialog} style={{ width: '450px' }} header={languageService.getText("Confirm")} modal footer={deleteTagValueDialogFooter} onHide={hideDeleteTagValueDialog}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                        {tag && <span>{languageService.getText("Are_you_sure_you_want_to_delete")}  <b>{tagValue.name}</b>?</span>}
                    </div>
                </Dialog>
            </div>
        );
    }
    else {
        return (
            <div className="datatable-crud-demo">
                <div className="card">
                    <b>{languageService.getText("Permission_Denied")}</b>
                </div>
            </div>
        );
    }
}